import React, { useEffect, useState } from "react";
import "./QuizAnswer.css";
import Army from "./Army.png";
import Family from "./Family.png";
import Machine from "./Machine.png";
import SportsTeam from "./SportsTeam.png";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import Form from "./Form";

const theme = createMuiTheme({
  body1: {
    fontFamily: "'Montserrat', sans-serif",
  },
});

const QuizAnswer = (props) => {
  const [image, setImage] = useState(null);
  const [content, setContent] = useState(null);
  const [persona, setPersona] = useState("");
  const [subtitle, setSubtitle] = useState("");

  useEffect(() => {
    if (props.quizvalue <= 699) {
      const Image = (
        <img className="quiz_answer_image_width" src={Army} alt="army" />
      );
      setImage(Image);
      setPersona("Your Company’s Persona: Army");
      setSubtitle("Your process needs improvements.");
      const text = (
        <div className="quiz_answer_content">
          <div>
            Much like the army your performance management system is technically
            sound, and is supposed to help you make clear decisions with a high
            success rate. Sadly this system may leave your team wanting a lot
            more despite achieving some critical goals. Army styled personas
            tend to be:
          </div>
          <ul style={{ marginLeft: "15px" }}>
            <li> Transactional</li>
            <li> Transformational</li>
            <li> Autocratic</li>
          </ul>
          <div>
            People would like to feel a sense of authenticity, flexibility, and
            more nuanced feedback more often. Simple ways of improving this
            within the company could be to
          </div>
          <ul style={{ marginLeft: "15px" }}>
            <li>
              make goals more transparent for all, and improve the frequency at
              which they’re revisited or revised.
            </li>
            <li>
              have a specific tool that helps with goal management and moving
              away from sheets or ppts
            </li>
            <li>
              not just discussing tasks KPIs in 1:1s, but also discussing
              motivation, feedback, employee engagement, emotions and energy!
            </li>
          </ul>
        </div>
      );
      setContent(text);
    } else if (props.quizvalue <= 999) {
      const Image = (
        <img className="quiz_answer_image_width" src={Machine} alt="machine" />
      );
      setImage(Image);
      setPersona("Your Company’s Persona: Machine ");
      setSubtitle(
        "Your performance management process is good but inconsistent"
      );
      const text = (
        <div className="quiz_answer_content">
          <div>
            Your performance management process is much like your beloved office
            machine, the printer. Sometimes it's great and functions smoothly
            where no one really notices it, when suddenly there's a paper jam
            right before you are desperate for it to work and things aren’t
            looking up. Mechanical persona tends to focus on elements such as:
          </div>
          <ul style={{ marginLeft: "15px" }}>
            <li> Schedules and systems</li>
            <li> Personal performance</li>
            <li> Deadlines and maintenance </li>
          </ul>
          <div>
            To raise performance in such a situation one would have to go beyond
            what’s immediately in sight. Here you’d want to improve by:
          </div>
          <ul style={{ marginLeft: "15px" }}>
            <li>
              Providing more regular feedback that’s nuanced not only caters to
              your team members work but also act as a coach for continuous
              improvement
            </li>
            <li>
              Though you may have insight into your immediate team member’s
              goals, making transparent goals for all to see may help give more
              clarity on company objectives and keep everyone accountable.
            </li>
          </ul>
          <div>
            Increasing the frequency of manager 1:1s may also give you a deeper
            insight into improvements that can be implemented so you can avoid
            being blindsided by hurdles that you may only become aware of a few
            months in the future!
          </div>
        </div>
      );
      setContent(text);
    } else if (props.quizvalue <= 1199) {
      const Image = (
        <img className="quiz_answer_image_width" src={Family} alt="family" />
      );
      setImage(Image);
      setPersona("Your Company’s Persona: Family ");
      setSubtitle("You're a strong performer!");
      const text = (
        <div className="quiz_answer_content">
          <div>
            To be honest, your performance management system does a solid job on
            the whole so great job getting it to this point! It gives employees
            the feedback they need to feel appreciated and helps them generally
            understand how they can grow and develop themselves and their
            skills. This system has the following traits:
          </div>
          <ul style={{ marginLeft: "15px" }}>
            <li>
              Managers take a great deal of interest in personal development and
              employee wellbeing{" "}
            </li>
            <li>
              The team acts as a family and moves in the direction of growth
              together
            </li>
            <li>
              Though structured within a system, it’s very democratic and each
              member of the ‘family’ has a platform to raise their concerns and
              opinions{" "}
            </li>
          </ul>
          <div>
            You’re almost there, and it’s the final stretch to the top. There
            are still some measures you can take to make it all the better:
          </div>
          <ul style={{ marginLeft: "15px" }}>
            <li>
              Though you are taking more into consideration and going beyond
              just appraisals, taking feedback into account from peers may also
              help to give a more detailed account, one that may have been
              missed by managers or team leaders.
            </li>
            <li>
              Finding more occasions not only to provide, but also record
              feedback can help establish a clear trajectory on the growth and
              development of your people
            </li>
            <li>
              Don’t be afraid to adjust and realign goals. You’ll be surprised
              at how much you can achieve when you revisit some conversations
              more frequently.
            </li>
          </ul>
        </div>
      );
      setContent(text);
    } else {
      const Image = (
        <img
          className="quiz_answer_image_width"
          src={SportsTeam}
          alt="sports team"
        />
      );
      setImage(Image);
      setPersona("Your Persona: Sports Team ");
      setSubtitle("You're a top performer!");
      const text = (
        <div className="quiz_answer_content">
          <div>
            Like a sports team which has coaches and leaders, your performance
            management process:
          </div>
          <ul style={{ marginLeft: "15px" }}>
            <li> consistently motivates top talent</li>
            <li> enables conversations on goals & progress</li>
            <li>
              uses the best technology available to make your people the
              happiest they could be.
            </li>
          </ul>
          <div>So way to go team!</div>
          <div>
            No matter if times get tough or better from the current time, you
            have a game plan that’ll see you through it all. Everyone who
            experiences your performance management process loves it. The people
            in your company feel:
          </div>
          <ul style={{ marginLeft: "15px" }}>
            <li> Heard</li>
            <li> Accountable</li>
            <li> And most importantly, motivated!</li>
            <li>Continue the great work because this is the big league!</li>
          </ul>
        </div>
      );
      setContent(text);
    }
  }, []);
  const [quizemail, setquizemail] = useState("");
  const quizformsubmit = (email) => {
    setquizemail(email);
  };
  const InClick = async (quizemail) => {
    setdisable(true);
    try {
      const response = await fetch(
        // "http://localhost:5000/contactLead",
        // "https://quiz-mesh.herokuapp.com/",
        "https://mesh-okr-core-lead.mesh.ai/contactLead",
        {
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: quizemail,
            contact: "yes",
          }),
        }
      );
      const data = await response.json();
      if (response.ok) {
        console.log(data);
      }
    } catch (err) {
      console.log(err.message);
    }
  };
  const [disable, setdisable] = useState(false);
  return (
    <ThemeProvider theme={theme}>
      <Form
        mcq1={props.mcq1}
        mcq2={props.mcq2}
        mcq3={props.mcq3}
        mcq4={props.mcq4}
        mcq5={props.mcq5}
        mcq6={props.mcq6}
        mcq7={props.mcq7}
        mcq8={props.mcq8}
        mcq9={props.mcq9}
        mcq10={props.mcq10}
        mcq11={props.mcq11}
        quizformsubmit={quizformsubmit}
      />
      <div>
        <div className="answer-component">
          <div>
            <div className="quiz_answer_image">{image}</div>
          </div>
          <div>
            <div className="quiz_answer_persona" style={{ marginTop: "40px" }}>
              <h1>{persona}</h1>
            </div>
            <div className="quiz_answer_subtitle">
              <b>{subtitle}</b>
            </div>
            <div className="quiz_answer_text">{content}</div>
          </div>
        </div>
        <div className="CTA_color" style={{ width: "100%", padding: "40px" }}>
          <div
            className="CTA_container"
            style={{
              backgroundColor: "#323846",
              borderRadius: "10px",
              color: "white",
            }}
          >
            <div>
              <h5 className="CTA_text">
                Interested in a free 30 minute call to help you improve?
              </h5>
            </div>
            <div>
              {disable && (
                <div class="CTA_button" style={{ cursor: "not-allowed" }}>
                  Request sent!
                </div>
              )}
              {!disable && (
                <div
                  class="CTA_button"
                  style={{ cursor: "pointer" }}
                  onClick={() => InClick(quizemail)}
                >
                  Yes, I'm in!
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default QuizAnswer;
